import React, { useState, useEffect } from "react";
import { db } from "../../../firebase";
import { useAuth } from "../../../contexts/AuthContext";
import Modal from "./Modal";
import Alert from "../../Alert";
import { svg } from "../../../resources/Svg";

const AddRecord = ({ open, setOpen, userInfo }) => {
  const { currentUser } = useAuth();
  const [todayExpenses, setTodayExpenses] = useState(0);
  const [todayRevenue, setTodayRevenue] = useState(0);
  const [desc, setDesc] = useState("");
  const [date, setDate] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [notificationMsg, setNotificationMsg] = useState("");

  useEffect(() => {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    const shortDate = year + "-" + month + "-" + day;
    setDate(shortDate);
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentUser != null) {
      if (!todayExpenses)
        return setErrorMsg("Please Enter the amount of expense today.");

      if (userInfo.isSalary) {
        setNotificationMsg("");
        setErrorMsg("");
        db.salaries
          .add({
            date: db.setFromDate.fromDate(new Date(date)),
            userId: currentUser.uid,
            todayExpense: Number(todayExpenses),
            description: desc,
          })
          .then(() => {
            setErrorMsg("");
            setTodayExpenses(0);
            setNotificationMsg("The data has been inserted successfully");
          })
          .catch((error) => {
            setTodayExpenses("");
            setNotificationMsg("");
            setErrorMsg(error.message);
          });
      } else {
        if (!todayRevenue)
          return setErrorMsg("Please Enter the amount of revenue today.");
        if (!todayExpenses)
          return setErrorMsg("Please Enter the amount of expense today.");

        setNotificationMsg("");
        setErrorMsg("");
        db.nonsalaries
          .add({
            date: db.setFromDate.fromDate(new Date(date)),
            userId: currentUser.uid,
            todayExpense: Number(todayExpenses),
            todayRevenue: Number(todayRevenue),
            description: desc,
          })
          .then(() => {
            setErrorMsg("");
            setTodayExpenses("");
            setTodayRevenue("");
            setNotificationMsg("The data has been inserted successfully");
          })
          .catch((error) => {
            setTodayExpenses("");
            setTodayRevenue("");
            setNotificationMsg("");
            setErrorMsg(error.message);
          });
      }
    }
  };
  return (
    <>
      <Modal open={open} h="auto">
        <div className="flex flex-col space-y-5">
          <div className="flex items-center justify-between">
            <h1 className="text-gray-800 text-xl font-semibold text-center">
              Add Record
            </h1>
            <button
              className="focus:outline-none"
              onClick={() => {
                setErrorMsg("");
                setNotificationMsg("");
                setTodayExpenses("");
                setOpen(false);
              }}
            >
              <svg
                className="h-6 w-6 text-red-600 "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            style={{ height: "1px" }}
            className="w-full bg-gray-700 bg-opacity-30 rounded-sm"
          ></div>
          <form className=" space-y-6" onSubmit={(e) => handleSubmit(e)}>
            <div className="space-y-6">
              <section className="flex flex-col mb-4">
                <label htmlFor="number" className="mb-2  text-gray-700">
                  Today Expenses
                </label>
                <input
                  spellCheck="false"
                  autoComplete="off"
                  className=" shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                  type="number"
                  name="number"
                  required
                  min={0}
                  step={0.01}
                  placeholder="Today Expenses Here"
                  onChange={(e) => setTodayExpenses(e.target.value)}
                />
              </section>
              {!userInfo?.isSalary && (
                <section className="flex flex-col mb-4">
                  <label htmlFor="number" className="mb-2  text-gray-700">
                    Today Revenue
                  </label>
                  <input
                    spellCheck="false"
                    autoComplete="off"
                    className=" shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                    type="number"
                    name="number"
                    required
                    min={0}
                    step={0.01}
                    placeholder="Today Revenue Here"
                    onChange={(e) => setTodayRevenue(e.target.value)}
                  />
                </section>
              )}
              <section className="flex flex-col mb-4">
                <label htmlFor="date" className="mb-2  text-gray-700">
                  Date
                </label>
                <input
                  className=" shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                  type="date"
                  name="date"
                  required
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </section>
              <section className="flex flex-col mb-4">
                <label htmlFor="decscription" className="mb-2  text-gray-700">
                  Short Description{" "}
                  <span className="text-gray-400">(Optional)</span>
                </label>
                <input
                  spellCheck="false"
                  autoComplete="off"
                  className="shadow-md py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                  type="text"
                  name="decscription"
                  placeholder="Short Description Here"
                  onChange={(e) => setDesc(e.target.value)}
                />
              </section>
            </div>

            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <svg
                  className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              Add Record
            </button>
          </form>
          {errorMsg && (
            <Alert
              svg={svg.danger}
              iconFlag={"red-500"}
              textFlag={"red-600"}
              text={errorMsg}
            />
          )}
          {notificationMsg && (
            <Alert
              svg={svg.success}
              bgColor={"green-100"}
              iconFlag={"green-500"}
              textFlag={"green-600"}
              text={notificationMsg}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default AddRecord;
